import { resourceNameCompletedCalendarEventId } from "motw_core/Entity/ICompletedCalendarEventId";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ICalendarState } from "../ICalendarState";
import { WithCalendarEventsChangingIndicatorAsync } from "../CalendarEvents/Render/Editor/WithCalendarEventsChangingIndicatorAsync";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";

export async function SetEventToNotDoneAsync(
    calendarEvent: ICalendarEvent,
    completionEventId: string
) {
    await WithCalendarEventsChangingIndicatorAsync(calendarEvent, async () => {
        await ClientDataProvider.DeleteRecordsAsync(
            `${resourceNameCompletedCalendarEventId}?eventid=eq.${completionEventId}`
        );

        // must await since event isn't completed until this data loads
        await Data.Load.Single.ByStateTarget<ICalendarState>(`eventData`);
    });
}
